var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOffline)?_c('v-system-bar',{attrs:{"app":"","color":"red lighten-2"}},[_c('div',{staticClass:"flex-grow-1"}),_c('v-icon',[_vm._v("signal_wifi_off")]),_c('span',[_vm._v("Você está desconectado.")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }